import { API } from 'aws-amplify'
async function getIndex () {
  console.log('Getting News Index...')
  let myInit = { response: false }
  return API.get('mctcnews', '/news', myInit)
}

async function getArticle (newsId) {
  console.log(`Getting Article #${newsId}...`)
  let myInit = { response: false }
  return API.get('mctcnews', `/news/${newsId}`, myInit)
}

async function createArticle () {}

async function editArticle () {}

export default {
  getIndex,
  getArticle,
  createArticle,
  editArticle
}
